function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { useEffect } from 'react';
/**
 * Хранилище модальных окон.
 */

import { collectPackageInfo } from '../../collectPackageInfo';
collectPackageInfo('Modal/ModalsContext');

var ModalsController = /*#__PURE__*/function () {
  function ModalsController() {
    _classCallCheck(this, ModalsController);

    _defineProperty(this, "items", []);
  }

  _createClass(ModalsController, [{
    key: "register",
    value: function register(id) {
      return this.items.push(id);
    }
  }, {
    key: "unregister",
    value: function unregister(id) {
      this.items.splice(this.items.indexOf(id), 1);
    }
  }]);

  return ModalsController;
}();

var controller = /*#__PURE__*/new ModalsController();
export var MODALS_PORTAL_ID = 'plasma-modals-root';
export var ModalsContext = /*#__PURE__*/React.createContext(controller);
export var ModalsProvider = function ModalsProvider(_ref) {
  var children = _ref.children;
  useEffect(function () {
    return function () {
      var portal = document.createElement('div');

      if (portal && document.body.contains(portal)) {
        document.body.removeChild(portal);
      }
    };
  }, []);
  return /*#__PURE__*/React.createElement(ModalsContext.Provider, {
    value: controller
  }, children);
};